exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app.flash{display:block;padding-top:50px}@media screen and (max-width:768px){#app.flash #target{top:60px}}", ""]);

// exports
